import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import { authHeader } from "../../common/apis/authHeader";
import moment from 'moment';
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";
var jwt = require('jsonwebtoken');

export const CompleteProfileAsyncCall = createAsyncThunk(
    "profile/CompleteProfileAsyncCall",
    async (values) => {
        values.dob = moment(values.dob).format("DDMMYYYY");
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/completeprofile", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const GetAsyncState = createAsyncThunk(
    "profile/State",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/state", value);
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const GetAsyncCity = createAsyncThunk(
    "profile/City",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/city", value);
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const GetProfileData = createAsyncThunk(
    "profile/getprofile",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/get_profile", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const UpdateProfileAsyncCall = createAsyncThunk(
    "profile/UpdateProfileAsyncCall",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/update_profile", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const VerifyUserEmailAsyncCall = createAsyncThunk(
    "profile/VerifyUserEmailAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/verifyemail", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
); 
export const VerifyUserEmailOtpAsyncCall = createAsyncThunk(
    "profile/VerifyUserEmailOtpAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/send-email-otp", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const VerifyUserEmailOtpVerifyAsyncCall = createAsyncThunk(
    "profile/VerifyUserEmailOtpVerifyAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/verify-email-otp", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const IDVerificationAsyncCall = createAsyncThunk(
    "profile/IDVerificationAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/verification", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const BankVerificationAsyncCall = createAsyncThunk(
    "profile/BankVerificationAsyncCall",
   
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/bankverification", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const UpiVerificationAsyncCall = createAsyncThunk(
    "profile/UpiVerificationAsyncCall",
   
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/users/upiverification", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

export const PlayerDetailAsyncCall = createAsyncThunk(
    "profile/PlayerDetailAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/player_detail", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);


export const TeamDetailAsyncCall = createAsyncThunk(
    "profile/TeamDetailAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/team_profile_detail", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data;
        }
    }
);

const initialState = {
    completeProfile: {},
    city: {},
    state_list: {},
    loading: "",
    profile: {},
    update_profile: {},
    verifyUserEmail: {},
    idVerification: {},
    bankVerification: {},
    upiVerification: {},
    player_detail: {},
    team_detail: {}
};

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        RemoveProfileStoreData: (state) => {
            //state.profile = {};
        },
        ResetPlayerDetails: (state) => {
            //state.player_detail = {};
        },
        ResetTeamDetails: (state) => {
            //state.team_detail = {};
        },
        ResetCityList: (state) => {
            //state.city = {};
        }        
    },
    extraReducers: {
        [CompleteProfileAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [CompleteProfileAsyncCall.fulfilled]: (state, { payload }) => {
            payload.data["timezone"]='Europe/Madrid3';
            var token = jwt.sign(payload.data, process.env.REACT_APP_JWT_SECRET);
            localStorage.setItem("auth_security", token)
            localStorage.setItem("auth_data", JSON.stringify(payload.data));
            return { ...state, completeProfile: payload, loading: false };
        },
        [CompleteProfileAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [GetAsyncState.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetAsyncState.fulfilled]: (state, { payload }) => {
            return { ...state, state_list: payload, loading: false };
        },
        [GetAsyncState.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [GetAsyncCity.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetAsyncCity.fulfilled]: (state, { payload }) => {
            return { ...state, city: payload, loading: false };
        },
        [GetAsyncCity.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [GetProfileData.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetProfileData.fulfilled]: (state, { payload }) => {
            return { ...state, profile: payload, loading: false };
        },
        [GetProfileData.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [UpdateProfileAsyncCall.pending]: (state, { payload }) => {
            return { ...state, loading: true };
        },
        [UpdateProfileAsyncCall.fulfilled]: (state, { payload }) => {
            var decodeProfileData = jwt.verify(localStorage.getItem("auth_security"), process.env.REACT_APP_JWT_SECRET)
            console.log("decodeProfileData-->>",decodeProfileData,payload.data);
    
            decodeProfileData.user_profile["name"] = payload.data.name
            decodeProfileData.user_profile["phone"] = payload.data.phone
            decodeProfileData.user_profile["dob"] = payload.data.dob
            decodeProfileData.user_profile["gender"] = payload.data.gender
            decodeProfileData.user_profile["address"] = payload.data.address
            decodeProfileData.user_profile["stateid"] = payload.data.stateid
            decodeProfileData.user_profile["cityid"] = payload.data.cityid
            decodeProfileData.user_profile["pincode"] = payload.data.pincode
            decodeProfileData.user_profile["profilepic"] = payload.data.profilepic
            decodeProfileData.user_profile["timezone"]='Europe/Madrid4';
            var token = jwt.sign(decodeProfileData, process.env.REACT_APP_JWT_SECRET);
            localStorage.setItem("auth_security", token)
            localStorage.setItem("auth_data",JSON.stringify(decodeProfileData));
            return { ...state, update_profile: payload, loading: false };
        },
        [UpdateProfileAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [VerifyUserEmailAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [VerifyUserEmailAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, verifyUserEmail: payload, loading: false };
        },
        [VerifyUserEmailAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [VerifyUserEmailOtpAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [VerifyUserEmailOtpAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, verifyUserEmail: payload, loading: false };
        },
        [VerifyUserEmailOtpAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [VerifyUserEmailOtpVerifyAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [VerifyUserEmailOtpVerifyAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, verifyUserEmail: payload, loading: false };
        },
        [VerifyUserEmailOtpVerifyAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [IDVerificationAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [IDVerificationAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, idVerification: payload, loading: false };
        },
        [IDVerificationAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [BankVerificationAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [BankVerificationAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, bankVerification: payload, loading: false };
        },
        [BankVerificationAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [UpiVerificationAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [UpiVerificationAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, upiVerification: payload, loading: false };
        },
        [UpiVerificationAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [TeamDetailAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [TeamDetailAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, team_detail: payload, loading: false };
        },
        [TeamDetailAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PlayerDetailAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PlayerDetailAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, player_detail: payload, loading: false };
        },
        [PlayerDetailAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },
    }
})

export const { RemoveProfileStoreData, ResetPlayerDetails, ResetCityList, ResetTeamDetails } = profileSlice.actions;
export const profileData = (state) => state.profile;
export const getCompleteProfileData = (state) => state.profile.completeProfile;
export const getState = (state) => state.profile.state_list;
export const getCity = (state) => state.profile.city;
export const getUserProfileData = (state) => state.profile.profile;
export const getUpdateUserProfileData = (state) => state.profile.update_profile;
export const getVerifyUserEmailData = (state) => state.profile.verifyUserEmail;
export const getIdVerificationData = (state) => state.profile.idVerification;
export const getBankVerificationData = (state) => state.profile.bankVerification;
export const getUpiVerificationData = (state) => state.profile.upiVerification;
export const getPlayerDetail = (state) => state.profile.player_detail;
export const getTeamsDetail = (state) => state.profile.team_detail;
export default profileSlice.reducer;
